<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Sponsor:</h3>
          </v-col>

          <v-col cols="12" xl="8" md="8" sm="8" xs="12">
            <v-text-field
              :maxlength="50"
              :counter="50"
              :rules="[v => (v || '' ).length <= 49 || 'La descripción no debe tener mas de 50 caracteres']"
              ref="name"
              v-model="name"
              outlined
              label="Nombre"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="4" xs="12">
            <v-select
              :items="countries"
              label="País"
              v-model="country_id"
              name="countries"
              :item-text="'name'"
              :item-value="'id'"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-textarea
              outlined
              :maxlength="350"
              :counter="350"
              :rules="[v => (v || '' ).length <= 349 || 'La descripción no debe tener mas de 350 caracteres']"
              ref="description"
              v-model="description"
              name="description"
              label="Descripción"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
      > 
        <v-row class="pa-4">
          <v-col cols="12">
            <h3 class="font-weight-regular">Redes:</h3>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="web"
              v-model="web"
              outlined
              label="Web"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="linkedin"
              v-model="linkedin"
              outlined
              label="Linkedin"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="instagram"
              v-model="instagram"
              outlined
              label="Instagram"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="facebook"
              v-model="facebook"
              outlined
              label="Facebook"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="twitter"
              v-model="twitter"
              outlined
              label="Twitter"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="youtube"
              v-model="youtube"
              outlined
              label="Youtube"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="whatsapp"
              v-model="whatsapp"
              outlined
              label="Whatsapp"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              ref="email"
              v-model="email"
              outlined
              label="Correo Electrónico"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
      > 
        <v-row class="pa-4">
          <v-col cols="12">
            <h3 class="font-weight-regular">Logo:</h3>
          </v-col>
          
          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!logo"
              v-model="logo"
              :rules="rules"
              @change="onLogoChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Logo"
              :messages="['Para una mejor visualización, usar un logo cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              max-width="380px"
              v-if="logo"
              wei>
              <v-img
                contain
                :src="url_logo"
                class="grey lighten-2"
                height="240px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteLogo()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'sponsorsEdition', params: { edition_id:this.edition_id, types_sponsor_id: this.types_sponsor_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_btn"
        :disabled="!logo"
        color="primary"
        @click="updateSponsor()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Actualizar
      </v-btn>
    </v-col>

    <v-dialog
        v-model="loading"
        overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            <label>Cargando...</label>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'newSponsorsEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      sponsor:[],
      name: null,
      description: null,
      web: null,
      linkedin: null,
      instagram: null,
      facebook: null,
      twitter: null,
      youtube: null,
      whatsapp: null,
      email: null,

      logo:null,
      url_logo:null,

      countries:[],
      country_id: null,

      rules: [
        (value) =>
          !value ||
          value.size < 2 ||
          "El archivo es demaciado grande",
      ],

      edition_id: null,
      types_sponsor_id: null,
      sponsor_id: null,
    }),

    methods:{
      async getCountries()
      {
        await axios.get('admin/countries').then(response =>{
          this.countries = response.data.data.countries
        }).catch(error => {
          console.log(error);
        })
      },

      async getSponsorEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/types-sponsors/'+this.types_sponsor_id+'/sponsors/'+this.sponsor_id).then(response =>{
          this.sponsor = response.data.data.sponsor
          
          this.name = this.sponsor.name
          this.country_id = this.sponsor.country_id
          this.description = this.sponsor.description
          this.web = this.sponsor.web
          this.linkedin = this.sponsor.linkedin
          this.instagram = this.sponsor.instagram
          this.facebook = this.sponsor.facebook
          this.twitter = this.sponsor.twitter
          this.youtube = this.sponsor.youtube
          this.whatsapp = this.sponsor.whatsapp
          this.email = this.sponsor.email

          this.logo = this.sponsor.logo
          this.url_logo = APP_URL+ this.logo

          this.loading=false
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      async updateSponsor()
      {
        this.loading_btn = true

        let formData= new FormData()
        formData.append('name', this.name)
        formData.append('country_id', this.country_id)
        formData.append('types_sponsor_id', this.types_sponsor_id)

        if(this.description!=null){
          formData.append('description', this.description);
        }

        if(this.web!=null){
          formData.append('web', this.web);
        }

        if(this.linkedin!=null){
          formData.append('linkedin', this.linkedin);
        }

        if(this.instagram!=null){
          formData.append('instagram', this.instagram);
        }

        if(this.facebook!=null){
          formData.append('facebook', this.facebook);
        }

        if(this.twitter!=null){
          formData.append('twitter', this.twitter);
        }

        if(this.youtube!=null){
          formData.append('youtube', this.youtube);
        }

        if(this.whatsapp!=null){
          formData.append('whatsapp', this.whatsapp);
        }

        if(this.email!=null){
          formData.append('email', this.email);
        }

        formData.append('logo', this.logo)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/types-sponsors/'+this.types_sponsor_id+'/sponsors/'+this.sponsor_id,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.dialog_new = false
            this.loading_btn = false
            this.loading = true
            this.$router.push({ name: 'sponsorsEdition', params: { edition_id: this.edition_id, types_sponsor_id: this.types_sponsor_id } })
          })
        } catch (error) {
          this.dialog_new_edition = false
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      onLogoChange() {
        this.url_logo = URL.createObjectURL(this.logo);
      },

      deleteLogo(){
        this.logo=null
        this.url_logo=null
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.types_sponsor_id = this.$route.params.types_sponsor_id
      this.sponsor_id = this.$route.params.sponsor_id
      this.getCountries().then(
        this.getSponsorEdition()
      )
    },
  }
</script>
